import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import cn from 'clsx';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import { SelectChangeEvent } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { getNodeData } from '../../../store';
import { SelectComponent } from '../../uiComponents';
import { OptionProps } from '../../../view-models';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';
import { cloneDeep } from 'lodash';
import { FieldMapperRow } from './fieldMapperRow';

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}

const GenerateGoogleComponentUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const initAttribute = useRef(componentData['attribute']);
  const [selClaims, setSelClaims] = useState<string[]>([]);
  const [claimsList, setClaimsList] = useState<OptionProps[]>([]);
  // const [selattributes, setSelAttributes] = useState<string[]>([]);
  const configData = jsonComponentsConfig.google.data;
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims, modifiedTemplatizations, setModifiedTemplatizations } = useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [enableMapBt, setEnableMapBt] = useState(false);
  const [nextExtraClaim, setNextExtraClaim] = useState({
    claimId: '',
    defaultValue: ''
  });
  // const allAADAttributes = useSelector(getJSONAADAttributes);
  const allNodeData = useSelector(getNodeData);
  const classes = jsonEditorStyles();

  useEffect(() => {
    const mapCA = allNodeData[componentData.id]?.attributes || [];
    setSelClaims(mapCA.map((m: any) => m.claim));
    // setSelAttributes(mapCA.map((m: any) => m.id));
  }, [allNodeData]);

  useEffect(() => {
    if (Object.keys(allClaims).length > 0) {
      const _temp = Object.keys(allClaims)
        .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
        .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
      setClaimsList(_temp);
    }
}, [allClaims]);

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || modifiedData?.indexProperty?.id === '' || modifiedData?.indexProperty?.claim === '' || (!sessionFieldsAreValid(modifiedData)));
    setUnsavedChanges(_res);
    setEnableMapBt(modifiedData['attribute']['claim'] && modifiedData['attribute']['id']);
    setSelClaims(
      modifiedData?.indexProperty?.claim
        ? modifiedData?.attributes.map((m: any) => m.claim).concat([modifiedData?.indexProperty?.claim])
        : modifiedData?.attributes.map((m: any) => m.claim),
    );
    // setSelAttributes(modifiedData?.attributes.map((m: any) => m.id));
  }, [modifiedData]);

  return (
    <>
      <FormControl required sx={{ m: 1, minWidth: 600 }}>
        <Box>
          <Typography gutterBottom variant="body1">
            Mapping of Google Partner claims to tenant attribute
          </Typography>
          <div>
            {modifiedData?.attributes.map((map: any, index: number) => {
              return (
                <div className={classes.flexRow} key={map.claim + map.id}>
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      const _temp = cloneDeep(modifiedData);
                      _temp['attributes'][index]['id'] = e.target.value;
                      setModifiedData(_temp);
                    }}
                    data={{
                      value: map.id,
                      label: 'Partner Claim Type',
                      required: true,
                      style: { margin: 1, width: 200 },
                      options: configData.partnerClaimTypes
                        // .filter(
                        //   (a) => !selattributes.find((s) => s === a),
                        // )
                        .reduce(
                          (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                          [{ label: map.id, value: map.id }],
                        )
                        .sort((a: OptionProps, b: OptionProps) =>
                          a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1,
                        ),
                    }}
                  />
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      const _temp = cloneDeep(modifiedData);
                      _temp['attributes'][index]['claim'] = e.target.value;
                      setModifiedData(_temp);
                    }}
                    data={{
                      value: map.claim,
                      label: 'Claim',
                      required: true,
                      style: { margin: 1, width: 200 },
                      options: Object.keys(allClaims)
                        .filter((c) => !selClaims.find((s) => s === c) && allClaims[c]?.dataType === 'string')
                        .reduce(
                          (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                          [{ label: map.claim, value: map.claim }],
                        )
                        .sort((a: OptionProps, b: OptionProps) =>
                          a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1,
                        ),
                    }}
                  />
                  <div>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 1, mb: 2 }}
                      onClick={() => {
                        const _temp = cloneDeep(modifiedData);
                        _temp['attributes'].splice(index, 1);
                        setModifiedData(_temp);
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
          <div className={classes.flexRow}>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({ ...modifiedData, attribute: { ...modifiedData['attribute'], id: e.target.value } });
              }}
              data={{
                value: modifiedData?.attribute?.id,
                label: 'Partner Claim Type',
                style: { margin: 1, width: 200 },
                options: configData.partnerClaimTypes
                  // .filter((a) => !selattributes.find((s) => s === a))
                  .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
                  .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
              }}
            />
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({
                  ...modifiedData,
                  attribute: { ...modifiedData['attribute'], claim: e.target.value },
                });
              }}
              data={{
                value: modifiedData?.attribute?.claim,
                label: 'Claim',
                style: { margin: 1, width: 200 },
                options: Object.keys(allClaims)
                  .filter((c) => !selClaims.find((s) => s === c) && allClaims[c]?.dataType === 'string')
                  .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
                  .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
              }}
            />
            <div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 1, mb: 2 }}
                onClick={() => {
                  setModifiedData((prv: any) => ({
                    ...modifiedData,
                    attributes: [...modifiedData['attributes'], modifiedData.attribute],
                    attribute: initAttribute.current,
                  }));
                }}
                disabled={!enableMapBt}
              >
                + Map
              </Button>
            </div>
          </div>
          <Typography gutterBottom variant="body1">
            Additional Claims to Output
          </Typography>
          {modifiedData['extraOutputClaims'].map((eocRef: any, ocIdx: number) => {
            return (
              <FieldMapperRow
                key={ocIdx}
                rowData={eocRef}
                writeback={(rowData) => {
                  const _eOutClaims = modifiedData['extraOutputClaims'].slice();
                  _eOutClaims[ocIdx] = rowData;
                  setModifiedData({
                    ...modifiedData,
                    extraOutputClaims: _eOutClaims
                  })
                }}
                claimsList={claimsList.reduce((opts: OptionProps[], nxt: OptionProps) => {
                  if (!modifiedData['extraOutputClaims'].find((eoc: any) => { return eoc.claimId === nxt.value })) {
                    opts.push(nxt);
                  }
                  return opts;
                }, [{value: eocRef.claimId, label: eocRef.claimId }])}
                allClaims={allClaims}
                enabledSources={['claim']}
                fixedSourceType='claim'
                sourceFieldName='claimId'
                sourceFieldLabels={{ claim: 'Claim' }}
                defaultValueFieldLabel='Default Value'
                defaultValueFieldName='defaultValue'
                allowEmptyDefaultValue={false}
                buttonText='Delete'
                buttonAction={() => {
                  const _eOutClaims = modifiedData['extraOutputClaims'].filter((cl: any, clIdx: number) => { return clIdx !== ocIdx });
                  setModifiedData({
                    ...modifiedData,
                    extraOutputClaims: _eOutClaims
                  });
                }}
              />
            );
          })}
          <FieldMapperRow
            rowData={nextExtraClaim}
            writeback={(rowData) => {
              setNextExtraClaim(rowData);
            }}
            claimsList={claimsList.reduce((opts: OptionProps[], nxt: OptionProps) => {
              if (!modifiedData['extraOutputClaims'].find((eoc: any) => { return eoc.claimId === nxt.value })) {
                opts.push(nxt);
              }
              return opts;
            }, [])}
            allClaims={allClaims}
            enabledSources={['claim']}
            fixedSourceType='claim'
            sourceFieldName='claimId'
            sourceFieldLabels={{ claim: 'Claim' }}
            defaultValueFieldLabel='Default Value'
            defaultValueFieldName='defaultValue'
            allowEmptyDefaultValue={false}
            buttonText='Add'
            buttonAction={() => {
              const _eOutClaims = modifiedData['extraOutputClaims'].slice();
              _eOutClaims.push({ claimId: nextExtraClaim.claimId, defaultValue: nextExtraClaim.defaultValue });
              setModifiedData({
                ...modifiedData,
                extraOutputClaims: _eOutClaims
              });
              setNextExtraClaim({
                claimId: '',
                defaultValue: ''
              });
            }}
            buttonDisabled={(!nextExtraClaim.claimId) || (!nextExtraClaim.defaultValue)}
          />
        </Box>
        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeGritComponent(cloneDeep(modifiedData), modifiedTemplatizations);
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
      </FormControl>
    </>
  );
};

// export default withAITracking(reactPlugin, GenerateGoogleComponentUI);
export default GenerateGoogleComponentUI;
